import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import {
  carouselTargetsGoogle,
  isSquareCarouselMedia,
  isVideoCarouselMedia,
} from './carouselGoogleMedia'

const ALLOWED_RATIOS = [1, 4 / 5, 3 / 4]
const RATIO_TOLERANCE = 0.02

const isVideoMedia = isVideoCarouselMedia

const hasUnsupportedRatio = (media, targetsGoogle) => {
  if (!media?.width || !media?.height || isVideoMedia(media)) return false
  if (targetsGoogle) return !isSquareCarouselMedia(media)

  const ratio = media.width / media.height
  return !ALLOWED_RATIOS.some((allowedRatio) => Math.abs(ratio - allowedRatio) <= RATIO_TOLERANCE)
}

export const useCarouselWarnings = ({ cards = [], platforms }) => {
  const { t } = useTranslation()
  const targetsGoogle = carouselTargetsGoogle(platforms)

  return useMemo(() => {
    const cardWarningsById = {}
    let hasVideoWarning = false
    let hasAspectRatioWarning = false
    // Google's rules are hard rejections at boost, not soft placement advice,
    // so a card that breaks them gets different copy from Meta's warning.
    const context = targetsGoogle ? 'google' : undefined

    cards.forEach((card) => {
      const media = card?.media
      if (!media) return

      const cardWarnings = []

      if (isVideoMedia(media)) {
        hasVideoWarning = true
        cardWarnings.push(
          t('Recommendations.campaign.setup.carouselAd.warnings.card.video', { context }),
        )
      }

      if (hasUnsupportedRatio(media, targetsGoogle)) {
        hasAspectRatioWarning = true
        cardWarnings.push(
          t('Recommendations.campaign.setup.carouselAd.warnings.card.aspectRatio', { context }),
        )
      }

      if (cardWarnings.length) {
        cardWarningsById[card.id] = cardWarnings
      }
    })

    const groupWarnings = []
    if (hasVideoWarning) {
      groupWarnings.push(
        t('Recommendations.campaign.setup.carouselAd.warnings.group.video', { context }),
      )
    }

    if (hasAspectRatioWarning) {
      groupWarnings.push(
        t('Recommendations.campaign.setup.carouselAd.warnings.group.aspectRatio', { context }),
      )
    }

    return {
      groupWarnings,
      cardWarningsById,
    }
  }, [cards, t, targetsGoogle])
}
